import Query from '../../components/Report';

const query = new Query('search-device');

export default query;
